import { render } from "./progress-spinner.vue?vue&type=template&id=43b9a7e3&scoped=true"
import script from "./progress-spinner.vue?vue&type=script&lang=js"
export * from "./progress-spinner.vue?vue&type=script&lang=js"

import "./progress-spinner.vue?vue&type=style&index=0&id=43b9a7e3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-43b9a7e3"

export default script